<template>
  <div v-if="showSuccessModal" class="mc-modal__success-urgent">
    <div class="mc-modal__success-urgent-icon">
      <img src="@/assets/images/bell-icon.svg" />
    </div>
    <div class="mc-modal__success-urgent-title">
      <h4>{{ $t('notification.alert.successActive') }}</h4>
      <p>{{ $t('notification.alert.tips') }}</p>

      <McButton
        :text="$t('notification.alert.tipsSetting')"
        variant="outline-primary"
        size="lg"
        block
        @click="openHelpPage"
      />
      <p class="my-4 blue-500" @click="closeModal">{{ $t('global.action.close') }}</p>
    </div>
  </div>
</template>
<script>
import McButton from '@/components/McButton'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    McButton,
  },
  computed: {
    ...mapState('modal', ['showSuccessModal']),
  },
  methods: {
    ...mapActions('modal', ['closeSuccessModal']),
    closeModal() {
      this.closeSuccessModal()
    },
    openHelpPage() {
      window.open('https://kb.mceasy.com/docs/pengaturan-interval-notifikasi-mendesak/', '_blank')
    },
  },
}
</script>
<style lang="scss" scoped>
.mc-modal__success-urgent {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  box-sizing: border-box;
  padding: 30px;
  background-color: $white;
  border-radius: 3px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  text-align: center;
  z-index: 2;
}

.mc-modal__success-urgent-icon {
  img {
    width: 100px;
  }
}

.mc-modal__success-urgent-title {
  h4 {
    font-size: 20px;
    font-weight: 500;
    margin: 30px 0;
  }
  p {
    margin-bottom: 30px;
  }
}
</style>